module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAYCAMAAAA73KjcAAAAVFBMVEX////7+Pnq1NrWrrrEiJqwYnmePFmOHj+NGz3p09rSpbKtWnOPH0H37/HTprSxY3udO1j79/jWrbnDh5mwYXjp0tnVrLjDhpivYHidOliyZHvSprMhV5TVAAAAW0lEQVR4Ae2TtQHAQAwDw8wM+++Z0lWe1ekGMOoiJXGSZnlRVp5EWuK6aTtkk34YJ9kDtslcL+s2leAm+3Fed4k91yNvhz4+ebGPj+Uj3k3oCT2hJ/SEntATTz4moTaLdNMe7wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/qa.png
// module id = mf1A
// module chunks = 0